module.exports = __webpack_public_path__ + "img/gatorz-frame-specs.b62e640f.png";